const ArrowCollapse = (props: React.HTMLAttributes<SVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="14"
    viewBox="0 0 23 14"
    fill="none"
  >
    <path
      d="M22.5607 0.628793C23.1464 1.21458 23.1464 2.16433 22.5607 2.75011L11.5 13.8108L0.43934 2.75011C-0.146447 2.16433 -0.146447 1.21458 0.43934 0.628794C1.02513 0.0430073 1.97487 0.0430074 2.56066 0.628794L11.5 9.56813L20.4393 0.628793C21.0251 0.0430065 21.9749 0.0430065 22.5607 0.628793Z"
      fill="currentColor"
    />
  </svg>
);
export default ArrowCollapse;
